module.exports = __webpack_public_path__ + "img/m5-4h.6c203b80.png";